import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchData } from "../../utils";
import { setNotification } from "../notificationsSlice";
import { has } from "lodash";
import { API_CONTRACT, API_CONTRACT_DETAILS, API_ORG_CONTRACT } from "../../settings";


export const getContractDetails = createAsyncThunk(
    "getContractDetails",
    async(contract, { dispatch, rejectWithValue }) => {
        try {
            const response = await fetchData(API_CONTRACT_DETAILS(contract), {}, {});
            if (has(response, "result")) {
                return response.result;
            }
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue({ code: e.code });
        };
        return rejectWithValue({});
    }
);

export const activateContract = createAsyncThunk(
    "activateContract",
    async({ contractName, activeFlag }, { dispatch, rejectWithValue }) =>{
        try {
            const response = await fetchData(`${API_CONTRACT}/${activeFlag ? "activate" : "deactivate"}`, {
                method: "PUT",
                headers: {
                    "X-Contract-Name": contractName
                }
            }, {});
            dispatch(setNotification(response.result));
            return { entity: "contracts", ...response.result};
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue(e);
        };
    }
);

export const deleteOrgContract = createAsyncThunk(
    "deleteOrgContract",
    async({ alias, contract }, { dispatch }) => {
        try {
            const response = await fetchData(API_ORG_CONTRACT, {
                method: "DELETE",
                headers: {
                    "X-Org-Alias": alias,
                    "X-Contract-Name": contract
                }
            }, {});
            dispatch(setNotification(response.result));
            return {entity: "contracts", ...response.result};
        } catch (e) {
            dispatch(setNotification(e));
        };
    }
);

export const updateContractsDate = createAsyncThunk(
    "updateContractsDate",
    async({ contract, endDate }, { dispatch, rejectWithValue }) => {
        try {
            const response = await fetchData(API_CONTRACT + "/massupdate", {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    contract_name: contract,
                    end_date: endDate
                })
            }, {});
            dispatch(setNotification(response.result));
            return { entity: "contracts", ...response.result };
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue(e);
        };
    }
);

export const deleteContract = createAsyncThunk(
    "deleteContract",
    async(contract, { dispatch, rejectWithValue }) => {
        try {
            const response = await fetchData(API_CONTRACT_DETAILS(contract), {
                method: "DELETE"
            }, {});
            dispatch(setNotification(response.result));
            return response.result;
        } catch (e) {
            dispatch(setNotification(e));
            return rejectWithValue();
        };
    }
);